module.exports = __webpack_public_path__ + "static/lisa-kirtman-fdeb4561a4009c3c4deddd5911430bae.jpg";